import { MESSAGE_NOTIFY, MESSAGE_NOTIFY_HIDE } from '../actions/message'

let ID = 0;
const initialState = {
  values: []
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case MESSAGE_NOTIFY:
      let { message } = action;

      return Object.assign({}, state, {
        values: state.values.concat([{
          id: ID++,
          message
        }])
      });

    case MESSAGE_NOTIFY_HIDE:
      let { id } = action;

      return Object.assign({}, state, {
        values: state.values.filter((item) => item.id !== id)
      });


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/message.js